<script setup lang="ts">
import {
  IncidentId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import PocketIncidentsTeamSelectionButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidentsTeamSelectionButton.vue'

interface Props {
  incidentId: IncidentId
  title: string
}
defineProps<Props>()
</script>

<template>
  <PocketIncidentsTeamSelectionButton
    :title
    :incidentId
    :additionalOptions="[
      {
        name: 'Technical timeout',
        value: VolleyballIncidentId.TechnicalTimeout,
      },
    ]"
  />
</template>
